import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToHospitalFormController } from './ReferralToHsopitalForm/ReferralToHospitalForm.types';

type ReferralToHospitalRouteLeavingGuardProps = {
   readonly visitId: number;
   readonly formState: ReferralToHospitalFormController['formState'];
   readonly handleSubmitDraft: ReferralToHospitalFormController['handleSubmitDraft'];
   readonly electronic: boolean;
};

export const ReferralToHospitalRouteLeavingGuard = (props: ReferralToHospitalRouteLeavingGuardProps): JSX.Element => {
   const { executeAsync: saveReferralToHospitalDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });
   return (
      <RouteLeavingGuard
         testId={'referralToSpecialist'}
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (formValues) =>
            saveReferralToHospitalDraft({
               token: getReferralDraftToken(
                  props.electronic ? 'electronicReferralToHospital' : 'referralToHospital',
                  props.visitId
               ),
               tags: props.electronic
                  ? undefined
                  : [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: formValues,
            })
         )}
         successMessage={referralTranslationKeys.referralDraftSaved}
      />
   );
};
